<template>
  <div class="h100vh-140">
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <!--<div class='h-inputBox'>-->
        <!--  <ejs-dropdownlist :dataSource="productList" v-model="product"-->
        <!--      :fields="fieldsType" name="productCheck"  @change="productChange" ></ejs-dropdownlist>-->
        <!--</div>-->
        <div class="h-inputBox">
               {{$t('Monitor.task.sampleStart')}}:
              <ejs-datetimepicker ref="dataStart" class="e-input e-disabled e-input-group" name="StartDate"
              :format="dateFormat.format" v-model="monitorTask.sampleStart" :locale="locale"  @change="getMonitorTaskList" ></ejs-datetimepicker>

              {{$t('Monitor.task.sampleEnd')}}:
              <ejs-datetimepicker ref="dataEnd" class="e-input e-disabled e-input-group" name="EndDate"
              :format="dateFormat.format" v-model="monitorTask.sampleEnd" :locale="locale"   @change="getMonitorTaskList"></ejs-datetimepicker>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="monitorTaskLogData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true' >
          <e-columns>
            <!-- <e-column type="checkbox" width="50" textAlign="center"></e-column> -->
            <e-column field="id" :visible="false"></e-column>
            <!--<e-column field="product" :headerText="$t('Monitor.record.product')" width="120" textAlign="Center"></e-column>-->
            <e-column field="systemInfo" :headerText="$t('Monitor.record.systemInfo')" width="240" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <!-- <e-column field="taskId" :headerText="$t('Monitor.record.taskId')" width="120" textAlign="Center"></e-column> -->
            <e-column field="recoreTime" :headerText="$t('Monitor.record.recoreTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="cpu" :headerText="$t('Monitor.record.cpu')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="cpuThreshold" :visible="false" :headerText="$t('Monitor.record.cpuThreshold')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="memory" :headerText="$t('Monitor.record.memory')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="memoryThreshold" :visible="false" :headerText="$t('Monitor.record.memoryThreshold')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="space" :headerText="$t('Monitor.record.diskSpace')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="spaceThreshold" :visible="false" :headerText="$t('Monitor.record.diskSpaceThreshold')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="networkRxRate" :headerText="$t('Monitor.record.networkRxRate')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="networkTxRate" :headerText="$t('Monitor.record.networkTxRate')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="iopsKbRead" :headerText="$t('Monitor.record.IOPSKbRead')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="iopsKbWrite" :headerText="$t('Monitor.record.IOPSKbWrite')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="queueOperands" :headerText="$t('Monitor.record.queueOperands')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="databaseDiskSpaceIsUsed" :headerText="$t('Monitor.record.databaseDiskSpaceIsUsed')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
            <e-column field="snmpAlarmDataSize" :headerText="$t('Monitor.record.snmpAlarmDataSize')" width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getMonitorTaskList"
        ></ejs-pager>
      </div>
  </div>
</template>
<script>
import {ExcelExport} from '@syncfusion/ej2-vue-grids';

export default {
  name: 'monitorSystemLog',
  provide: {
    grid: [ExcelExport]
  },
  components: {
  },
  data() {
    return {
      monitorTaskLogData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Monitor.monitor')}` + '/' + `${this.$t('Monitor.record.titleName')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
      ],
      locale: localStorage.getItem('locale'),
      product: '',
      productList: [],
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      monitorTask: {
                    taskName: '',
                    product: 'PLATFORM',
                    sampleStart: '',
                    sampleEnd: '',
                },
      dateFormat: {
        type: 'date', format: 'yyyy-MM-dd HH:mm:ss'
      },
      fieldsType: {
          text: "text",
          value: "value"
      },
      addStatus: true,
      screenHeight: document.body.clientHeight - 240
    };
  },
  mounted() {
    this.getMonitorTaskList();
    this.getProductList();
    let That = this;
  },
  methods: {
    typeFormat(grids, data) {
      if(data.exeCycle == 'run'){
        return `${this.$t('Monitor.record.run')}`;
      }else if(data.exeCycle == 'start'){
        return `${this.$t('Monitor.record.start')}`;
      }
    },
    getMonitorTaskList() {
      const url = '/lte/ems/sys/monitor/log/queryMonitorTaskLog';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        product: this.product,
        pageNo: this.page.pageNo,
        pageSize: this.pageSettings.pageSize,
        startTime:this.monitorTask.sampleStart=='' ? '' : Date.parse(this.monitorTask.sampleStart),
        endTime:this.monitorTask.sampleEnd=='' ? '' : Date.parse(this.monitorTask.sampleEnd)
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          if (!!v.recoreTime) {
            let date = new Date();
            date.setTime(v.recoreTime);
            v.recoreTime = date;
          }
        });
        That.monitorTaskLogData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    productChange(msg){
      this.product = msg.value;
      this.getMonitorTaskList();
    },
    getProductList() {
      this.$axios.get("/lte/ems/sys/monitor/log/findProducts").then(response => {
          let resultVal = response.data.resultVal;
          resultVal = resultVal.filter(item => !item.includes('ems_5gc') && !item.includes('ems_gnb') && !item.includes('ems_tr069'));
          this.productList.push({ text: "All", value: "" });
          for (let i = 0; i < resultVal.length; i++) {
              this.productList.push({
                  text: resultVal[i],
                  value: resultVal[i],
              });
          }
      });
    },
    filterMonitorTask() {
      this.getMonitorTaskList();
    },
    refreshGrid() {
      this.product='';
      this.getMonitorTaskList();
    },
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
